export default __webpack_public_path__ + "static/meeting-9d5640b7348ac7bf7c2f63a5670f7508.jpg";